import assetActionService from "../../../../services/assetService/assetActionService/assetActionService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { AssetActionInterface } from "../../../../models/AssetModel/AssetAction/AssetAction";

const useAssetActions = (assetId: string, page: number, pageSize: number) =>
  useQuery<AssetActionInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
      assetId,
    ],
    queryFn: () => assetActionService.GetAll(assetId, page, pageSize),
    initialData: [],
  });

export default useAssetActions;
